<template>
  <div>
    <el-dialog
      title="指定发货仓"
      :visible.sync="dialogVisible"
      width="950px"
      :before-close="handleClose"
    >
      <RightDeliveryWarehouse
        ref="RightDeliveryWarehouse"
        :disabled="disabled"
        show-reset-btn
      ></RightDeliveryWarehouse>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="confirm">下一步</el-button>
      </span>
    </el-dialog>
    <AppointLogistics
      ref="AppointLogistics"
      show-last-btn
      @confirm="getLogisticsData"
    ></AppointLogistics>
  </div>
</template>

<script>
import RightDeliveryWarehouse from './parcel/RightDeliveryWarehouse.vue';
import AppointLogistics from './AppointLogistics.vue';
export default {
  name: 'BusinessOrderSourceAppointDeliveryWarehouse',
  components: { RightDeliveryWarehouse, AppointLogistics },
  data() {
    return {
      data: {},
      dialogVisible: false,
      disabled: [],
    };
  },
  methods: {
    show(info) {
      this.data = info;
      // 已选中的禁用
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.RightDeliveryWarehouse.reset();
        this.$refs.RightDeliveryWarehouse.getData(this.data.tagList);
        this.$refs.RightDeliveryWarehouse.radio = info.stockWarehouseCode;
        this.$refs.RightDeliveryWarehouse.selectedData = {
          stockId: info.stockWarehouseId,
          stockNo: info.stockWarehouseCode,
          stockName: info.stockWarehouseName,
        };
      });
    },
    hide() {
      this.dialogVisible = false;
    },
    handleClose() {
      this.hide();
    },
    getLogisticsData(data) {
      this.$emit('confirm', data);
      this.hide();
    },
    confirm() {
      if (this.$refs.RightDeliveryWarehouse.radio === '') {
        this.$message.warning('请选择指定发货仓');
        return;
      }
      const data = {
        ...this.$refs.RightDeliveryWarehouse.selectedData,
      };
      this.$refs.AppointLogistics.show(data);
    },
  },
};
</script>

<style></style>
